export default {
    title: 'Our perception',
    action: 'Save',
    cancel: 'Cancel',
    empty: 'Nothing to see here, yet.',
    first: 'Create perception',
    success: 'The perception was successfully saved',
    updated: 'Last updated by {author}, {date}',
    errors: {
        required: 'Please add an evaluation text',
        length: 'The evaluation text must not exceed a length of 1000 characters'
    }
}
